import './Servicios.css';

const servicios = [
  {
    id: 'reefer',
    icon: '❄️',
    titulo: 'Transporte de Contenedores Refrigerador (Reefer)',
    descripcion:
      'Contamos con unidades con sistema Underslung Genset para el transporte de contenedores refrigerados de 20\' y 40\'.',
  },
  {
    id: 'plataforma',
    icon: '🚛',
    titulo: 'Transporte en Plataforma',
    descripcion:
      'Transporte de carga general, estructuras metálicas, materiales diversos, tuberías y harina de pescado.',
  },
  {
    id: 't3s3',
    icon: '✅',
    titulo: 'Configuración T3S3',
    descripcion:
      'Operamos según la normativa del Ministerio de Transporte y Comunicaciones del Perú.',
  },
  {
    id: 'gps',
    icon: '📡',
    titulo: 'Unidades con GPS Navitel',
    descripcion:
      'Monitoreo satelital en tiempo real para mayor seguridad y trazabilidad en cada operación.',
  },
];

export default function Servicios() {
  return (
    <section id="servicios" className="servicios">
      <div className="container">
        <h2 className="section-title">Nuestros Servicios</h2>
        <div className="section-divider" />
        <div className="servicios__grid">
          {servicios.map((s) => (
            <div key={s.id} className="servicios__card">
              <div className="servicios__icon-wrap">
                <span className="servicios__icon">{s.icon}</span>
              </div>
              <div className="servicios__body">
                <h3 className="servicios__titulo">{s.titulo}</h3>
                <p className="servicios__desc">{s.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
